import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el material después de comprar?',
  a: 'Inmediatamente después del pago recibís un mail con el link de descarga de todos los PDFs. El acceso es de por vida.'
}, {
  q: '¿Sirve si todavía no empecé a rotar por guardia?',
  a: 'Sí. Podés estudiarlo antes de tu primera guardia para llegar con herramientas reales. Varios compradores lo usaron para preparar el concurso de residencia.'
}, {
  q: '¿Está en español argentino?',
  a: 'Todo el contenido está escrito en español rioplatense, adaptado a la realidad del hospital público argentino, con referencias a la Ley 26.657 y el sistema judicial argentino.'
}, {
  q: '¿Los 6 bonos están incluidos en las dos ofertas?',
  a: 'Sí. Los 6 bonos clínicos están incluidos tanto en el PRO como en el Elite. La diferencia es el Blindaje Legal Total que se suma en Elite.'
}, {
  q: '¿Sirve para el concurso de ingreso a residencia?',
  a: 'Sí. El razonamiento clínico y los protocolos de crisis te diferencian en la evaluación del concurso.'
}, {
  q: '¿Qué diferencia tiene con los libros tradicionales?',
  a: 'Los libros son teóricos y densos. Este sistema son plantillas, checklists y protocolos listos para usar bajo presión, en el momento crítico.'
}, {
  q: '¿Para qué nivel está pensado?',
  a: 'Para residentes desde el primer año, concurrentes, rotantes y psiquiatras con experiencia que quieren sistematizar su práctica y reducir su exposición legal.'
}, {
  q: '¿Por qué elegir el Elite y no el PRO base?',
  a: 'El PRO te da todo el sistema clínico. El Elite agrega el sistema de protección legal que construye tu escudo guardia a guardia. La pregunta no es si vas a enfrentar una situación legal, sino cuándo.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-8 md:py-20 bg-white" data-id="element-100">
      <div className="max-w-3xl mx-auto px-4" data-id="element-101">
        <div className="text-center mb-6 md:mb-10" data-id="element-102">
          <div className="inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-brand-bg rounded-full mb-2 md:mb-3" data-id="element-103">
            <HelpCircle className="w-5 h-5 md:w-6 md:h-6 text-brand-mid" data-id="element-104" />
          </div>
          <h2 className="text-[11px] md:text-sm font-bold text-brand-mid tracking-wider uppercase mb-1" data-id="element-105">
            Dudas Comunes
          </h2>
          <h3 className="font-heading text-[22px] md:text-4xl text-brand-dark" data-id="element-106">
            Preguntas Frecuentes
          </h3>
        </div>

        <div className="border-t border-gray-200" data-id="element-107">
          {faqs.map((faq, idx) => {
          const isOpen = openIdx === idx;
          return <div key={idx} className="border-b border-gray-200" data-id="element-108">
                <button onClick={() => setOpenIdx(isOpen ? null : idx)} className="w-full flex items-center justify-between py-3 md:py-5 text-left focus:outline-none group active:bg-gray-50/50 transition-colors" aria-expanded={isOpen} data-id="element-109">
                  <span className={`font-bold text-[13px] md:text-base pr-3 transition-colors leading-snug ${isOpen ? 'text-brand-mid' : 'text-gray-800 group-hover:text-brand-mid'}`} data-id="element-110">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-gray-400 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-brand-mid' : ''}`} data-id="element-111" />
                </button>
                <AnimatePresence data-id="element-112">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-113">
                      <p className="pb-4 md:pb-5 text-xs md:text-sm text-gray-600 leading-relaxed" data-id="element-114">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}